import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

export const wrapper = css`
  position: relative;
  flex-shrink: 0;
`;

export const productImg = {
  base: (theme: Theme) => css`
    background-color: ${theme.light.backgroundBase};
    border-radius: ${borders.radiusBase};
    aspect-ratio: auto;
    object-fit: scale-down;
    padding: 0.25rem;
    height: 100%;
    width: 100%;
  `,
  xxsmall: css`
    height: 2.625rem;
    width: 2.625rem;
  `,
  xsmall: css`
    height: 3.875rem;
    width: 3.875rem;
  `,
  small: css`
    height: 5.5rem;
    width: 5.5rem;
  `,
  medium: css`
    height: 6.875rem;
    width: 6.875rem;
  `,
  large: css`
    height: 9.125rem;
    width: 9.125rem;
  `,
  xlarge: css`
    height: 14rem;
    width: 14rem;
  `,
  xxlarge: css`
    height: 36.5rem;
    width: 36.5rem;
  `,
  isFaded: css`
    opacity: 50%;
  `,
  isPaddingless: css`
    padding: 0rem;
  `,
};

export const availabilityPill = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
`;

export const onlyOnFSPill = {
  base: css`
    position: absolute;
    top: 0.25rem;
    left: -0.25rem;
  `,
  outsideCorner: css`
    top: 0;
    left: 0;
    transform: translateY(-50%) translateX(-50%);
  `,
  outsideCornerTooltip: css`
    top: 0;
    left: 0;
    transform: translateY(-25%) translateX(-50%);
  `,
  pill: css`
    top: 1rem;
    left: 1rem;
  `,
};

export const qualityPartnerBadge = {
  base: css`
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  `,
  large: css`
    top: 1rem;
    right: 1rem;
  `,
  outsideCorner: css`
    top: 0;
    right: 0;
    transform: translateY(-50%) translateX(50%);
  `,
};
